/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 *  Possible values: Low = 0, Normal = 1, High = 2, Urgent = 3
 */
export enum Routemize_Entities_Metadata_NotePriority {
    LOW = 'Low',
    NORMAL = 'Normal',
    HIGH = 'High',
    URGENT = 'Urgent',
}
